<template>
    <div
        class="frame content-centered" 
        :class="{active: active, TA: isTestAchat}"
        @click="$emit('click')"
        >
        <h4>{{ title }}</h4>
        <SvgIcon :icon="type" class="icon content-centered" :class="{TA: isTestAchat}" fill :stroke="stroke" />
        <div class="check-button" :class="{TA: isTestAchat, radio:radio}"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        type: {
            type: String
        },
        title: {
            type: String
        },
        active: {
            type: Boolean
        },
        radio: {
            type:Boolean,
            default: true
        },
        stroke: {
            type:Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters("common", ["isTestAchat"])
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Energy/EnergyButton.vue